// Generiche
export * from './generic-section/GenericSection';
export * from './stripes-section/StripesSection';
export * from './banner-section/BannerSection';

// Specifiche
export * from './agencies-section/AgenciesSection';
export * from './news-section/NewsSection';
export * from './sold-properties-section/SoldPropertiesSection';
export * from './properties-for-sale-section/PropertiesForSaleSection';
export * from './reviews-section/ReviewsSection';
export * from './team-section/TeamSection';
